import { render, staticRenderFns } from "./newuser.vue?vue&type=template&id=1fdad45e&scoped=true&"
import script from "./newuser.vue?vue&type=script&lang=js&"
export * from "./newuser.vue?vue&type=script&lang=js&"
import style0 from "./newuser.vue?vue&type=style&index=0&id=1fdad45e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdad45e",
  null
  
)

export default component.exports